import { render } from "./ChargesList.vue?vue&type=template&id=991a0d6e"
import script from "./ChargesList.vue?vue&type=script&lang=js"
export * from "./ChargesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__